import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import Text from 'components/Text';

import cxHelpers from 'util/className';
import { titleize } from 'util/strings';

@cxHelpers('Label')
export default class Label extends PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    titleCase: PropTypes.bool,
    fontSize: PropTypes.string,
    textProps: PropTypes.object,
    boxProps: PropTypes.object,
  };

  static defaultProps = {
    titleCase: true,
    fontSize: 'fs14',
  };

  render() {
    const { children, titleCase, fontSize, ...props } = this.props;
    const text =
      typeof children === 'string' && titleCase
        ? titleize(this.props.children)
        : children;

    const textProps = {
      [fontSize]: true,
      ...this.props.textProps,
    };

    return (
      <Box {...this.props.boxProps}>
        <Text {...props} {...textProps} tag="label" className={this.cx()}>
          {text}
        </Text>
      </Box>
    );
  }
}
